import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Input, message, Card, Select, Tooltip, Switch, Button, Modal, ColorPicker } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import dayjs from 'dayjs';
import { AuthContext } from "../../Auth/AuthContext";

import { getSourceByID, updateTag, getTagById } from "../../utils/API";
// import { getTagByID, updateTag } from "../../utils/API"; // Adjusted API function names
const { Option } = Select;

interface EditTagModalProps {
    visible: boolean;
    tagId?: any;
    onClose: () => any;
    onSuccess: () => any;
}

const EditTagModal = (props: EditTagModalProps) => {
    const navigate = useNavigate();
    const { visible, onClose, tagId } = props;
    const { authData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const roleId = authData.roleId;

    useEffect(() => {
        const fetchTag = async () => {
            try {
                const response = await getTagById(tagId);
                if (!response || !response.tag) {
                    message.error("No tag data found.");
                    return;
                }

                console.log("API Response:", response); // Debug log

                // Set form values here using the nested tag object
                form.setFieldsValue({
                    name: response.tag.name,
                    color: response.tag.color,
                    category: response.tag.category,
                });
            } catch (error: any) {

                message.error(error.response.data.message)
                console.error("Fetch error:", error);
                message.error("Failed to load tag data");
            }
        };
        if (visible && tagId) {
            fetchTag();
        } else {
            // Reset form when modal is closed or no tagId
            form.resetFields();
        }
    }, [visible, tagId, form]);

    const handleUpdate = async (values: any) => {
        setLoading(true);
        const colorValue =
            typeof values.color === "string"
                ? values.color
                : values.color?.toHexString?.() || "#000000"; // fallback
        try {
            const payload = {
                _id: tagId,
                name: values.name,
                color: colorValue,
                category: values.category,
            };

            await updateTag(tagId, payload);

            message.success("Tag updated successfully!");

            if (props.onSuccess) props.onSuccess();
            if (onClose) onClose();

            setTimeout(() => {
                navigate("/tags");
            }, 100);
        } catch (error: any) {
            console.error("Update error:", error);

            if (error.response) {
                // ✅ Backend already sends proper messages
                message.error(error.response.data.message || "Failed to update tag");
            } else {
                message.error("Network error, please try again");
            }
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            centered={false}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Edit Tag
                </div>
            }
        >
            <Form
                onFinish={handleUpdate}
                form={form}
                layout="horizontal"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >
                {/* Tag Name */}
                <div className="elements">
                    <div className="flex justify-center gap-4">
                        <Form.Item
                            label={
                                <span style={{
                                    color: '#4b5563',
                                    fontFamily: 'inter, sans-serif',
                                    fontSize: '14px',
                                    paddingLeft: "15px",
                                    fontWeight: 500,
                                }}>
                                    Tag Name <span className="text-red-500">*</span>
                                </span>
                            }
                            name="name"
                            required={false}
                            rules={[{ required: true, message: "Please enter Tag name" }]}
                        >
                            <Input className="Allinput" placeholder="Tag Name" style={{ width: "380px" }} />
                        </Form.Item>

                        <Form.Item

                            required={false}
                            style={{ marginTop: "7px" }}
                            name="color"
                            rules={[{ required: true, message: "Please pick a color" }]}
                        >
                            <ColorPicker
                                format="hex"
                                disabled={false}
                                placement="bottomRight"
                                style={{ marginTop: "0px", position: "relative" }}
                                defaultValue={"#000000"}
                            // showText
                            />
                        </Form.Item>
                    </div>
                    <Form.Item
                        label={
                            <span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>
                                Category <span className="text-red-500">*</span>
                            </span>
                        }
                        name="category"
                        required={false}
                        rules={[
                            {
                                required: true,
                                message: "Please select a category",
                            },
                        ]}
                    >
                        <Select
                            mode="multiple"
                            size="large"
                            disabled={roleId == 2}
                            className="CustomSelect"
                            placeholder="Select category"
                        >
                            <Option value="Sales">Sales</Option>
                            <Option value="Contacts">Contacts</Option>
                        </Select>
                    </Form.Item>
                </div>

                {/* Submit Button */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-3"
                >
                    <div className="button-wrapper">
                        <button
                            className="allcanclebutton"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button className="allsubmitebutton" disabled={isLoading}>
                            {isLoading ? "Updating..." : "Update"}
                        </button>
                    </div>
                </Col>
            </Form>
        </Modal>
    );
};

export default EditTagModal;